import { type IconPath, icons } from "@/types/icons";

export type IconAssetProps = React.SVGProps<SVGSVGElement> & {
	path: IconPath;
	size?: number;
};

export function IconAsset({ path, size = 24, ...props }: IconAssetProps) {
	const IconComponent = icons[path];

	if (!IconComponent) return null;

	return <IconComponent width={size} height={size} {...props} />;
}
